import React from "react";
import { Navigate } from "react-router-dom";
import { useAppContext } from "../context/MainContext/AppContext";

const ProtectedRoute = ({ children }) => {
  const { database_user } = useAppContext();
  if (!database_user) {
    return <Navigate to="/" />;
  }

  return children;
};

export default ProtectedRoute;
